<template>
  <div class="detail-box show-detail-box">
    <a class="close" @click="$emit('closeShowDetailBox')">
      <close-outlined />
    </a>
    <div class="s-filter-box">
      <a-form layout="inline" :model="search">
        <a-form-item :label="rangeLabel">
          <a-range-picker v-model:value="search.dateRange" />
        </a-form-item>
        <a-form-item>
          <a-input
            allowClear
            class="w1"
            v-model:value="search.gon"
            placeholder="订单号"
          ></a-input>
        </a-form-item>
        <a-form-item>
          <a-input
            allowClear
            class="w1"
            v-model:value="search.serialNo"
            placeholder="主机序列号"
          ></a-input>
        </a-form-item>
        <a-form-item>
          <a-input
            allowClear
            class="w1"
            v-model:value="search.fgName"
            placeholder="fgName"
          ></a-input>
        </a-form-item>
        <a-form-item>
          <a-space>
            <a-button type="primary" @click="find">
              <template #icon><SearchOutlined /></template>
              Find
            </a-button>
            <a-button type="primary" @click="reset">
              <template #icon><rollback-outlined /></template>
              Reset
            </a-button>
          </a-space>
        </a-form-item>
      </a-form>
    </div>
    <div id="detail-table-box" class="table-box">
      <a-table
        :columns="columns"
        :row-key="(record) => record.id"
        :data-source="dataSource"
        :loading="loading"
        @change="tableChange"
        :pagination="{
          total: pageConfig.totalCount,
        }"
        size="small"
      ></a-table>
    </div>
  </div>
</template>
<script setup>
  import { ref, reactive, defineProps, computed } from 'vue'
  import dayjs from 'dayjs'
  import { logisticURL } from '@/config'
  import request from '@/utils/request'
  import {
    SearchOutlined,
    RollbackOutlined,
    CloseOutlined,
  } from '@ant-design/icons-vue'
  import { message } from 'ant-design-vue'
  const props = defineProps({
    curDetail: Object,
  })
  const search = reactive({
    dateRange: [],
  })
  const rangeLabel = computed(() => {
    let place = ''
    switch (props.curDetail.spoStatusCode) {
      case 'DELIVER_GOODS':
        place = '创建'
        break
      case 'PROCESSING':
        place = '实际提货'
        break
      case 'ARRIVED':
        place = '签收'
        break
      case 'INSTALLING':
        place = '签收'
        break
      case 'INSTALLED':
        place = '安装'
        break
      default:
        place = ''
    }
    return place
  })
  const pageConfig = reactive({
    pageSize: 10,
    pageIndex: 1, //当前页码
    totalCount: 0, //总记录数
  })
  const loading = ref(false)
  const columns = computed(() => {
    let es = []
    if (
      !['DELIVER_GOODS', 'PROCESSING'].includes(props.curDetail.spoStatusCode)
    ) {
      es = [
        {
          title: '实际送达时间',
          dataIndex: 'actDelivery',
          width: '10%',
          customRender({ text }) {
            return text ? dayjs(text).format('YYYY-MM-DD HH:mm:ss') : ''
          },
        },
        {
          title: '签收时间',
          dataIndex: 'signForDate',
          width: '10%',
          customRender({ text }) {
            return text ? dayjs(text).format('YYYY-MM-DD HH:mm:ss') : ''
          },
        },
      ]
    }
    return [
      {
        title: 'No',
        dataIndex: 'no',
        key: 'no',
        customRender({ index }) {
          return index + 1
        },
        width: '5%',
      },
      { title: '订单号', dataIndex: 'gon', width: '10%' },
      { title: 'JobId', dataIndex: 'jobId', width: '10%' },
      { title: '主机序列号', dataIndex: 'serialNo', width: '15%' },
      { title: 'fgName', dataIndex: 'fgName', width: '10%' },
      { title: '物流状态', dataIndex: 'shipmentStatus', width: '10%' },
      {
        title: '实际提货时间',
        dataIndex: 'actPick',
        width: '10%',
        customRender({ text }) {
          return text ? dayjs(text).format('YYYY-MM-DD HH:mm:ss') : ''
        },
      },
      ...es,
      {
        title: '创建时间',
        dataIndex: 'createOn',
        width: '10%',
        customRender({ text }) {
          return text ? dayjs(text).format('YYYY-MM-DD HH:mm:ss') : ''
        },
      },
    ]
  })
  const dataSource = ref([])
  const find = () => {
    const spoStatusList = [props.curDetail.spoStatusCode]
    const checkEmpty = Object.values(search).every((item) => {
      if (Array.isArray(item) && !item.length) {
        return true
      } else {
        return ['', undefined, null].includes(item)
      }
    })

    if (checkEmpty) {
      message.warning('请输入查询条件')

      return
      // 为空
    }
    const reqData = {
      ...search,
      pageNo: pageConfig.pageIndex,
      pageSize: pageConfig.pageSize,
      spoStatusList,
    }
    if (search.dateRange && search.dateRange.length) {
      const start = dayjs(search.dateRange[0]).valueOf()
      const end = dayjs(search.dateRange[1]).valueOf()
      switch (props.curDetail.spoStatusCode) {
        case 'PROCESSING':
          reqData.actPickState = start
          reqData.actPickEnd = end
          break
        case 'DELIVER_GOODS':
          reqData.createOnState = start
          reqData.createOnEnd = end
          break
        case 'ARRIVED':
          reqData.signForDateState = start
          reqData.signForDateEnd = end
          break
        case 'INSTALLING':
          reqData.signForDateState = start
          reqData.signForDateEnd = end
          break
        case 'INSTALLED':
          reqData.installDateState = start
          reqData.installDateEnd = end
          break
      }
    }

    delete reqData.dateRange
    loading.value = true
    request({
      method: 'post',
      url: '/api/v1/deliverySpo/selectDeliveryByPage',
      baseURL: logisticURL,
      data: reqData,
    })
      .then((res) => {
        dataSource.value = res.data.list
        pageConfig.totalCount = res.data.totalCount
      })
      .finally(() => {
        loading.value = false
      })
  }
  const reset = () => {
    Object.keys(search).forEach((key) => {
      search[key] = null
    })
    dataSource.value = []
    pageConfig.pageIndex = 1
    pageConfig.totalCount = 0
  }
  const tableChange = ({ current }) => {
    pageConfig.pageIndex = current
    find()
  }
</script>

<style lang="less" scoped>
  @import './css.less';
  .w1 {
    width: 150px;
  }
</style>
